import { useAutoSaveForm } from '../../../components/forms/useAutoSaveForm'
import FormHeader from '../../../components/forms/FormHeader'
import { api } from '../../../lib/api'
import Input from '../../../components/ui/Input'

interface State {
  title: string
  goal: number
  current: number
  color: string
  show: boolean
}

interface Props {
  overlayId: string
  initial: Record<string, unknown>
}

export default function SubscriberForm({ overlayId, initial }: Props) {
  const form = useAutoSaveForm<State>({
    initial: {
      title: (initial.title as string) || 'ABONE HEDEFİ',
      goal: Number(initial.goal) || 1000,
      current: Number(initial.current) || 0,
      color: (initial.color as string) || '#10b981',
      show: initial.show !== false,
    },
    onSave: async (s) => {
      await api(`/api/overlays/${overlayId}/state`, {
        method: 'PATCH',
        body: JSON.stringify(s),
      })
    },
  })

  const pct = form.draft.goal > 0
    ? Math.min(100, Math.round((form.draft.current / form.draft.goal) * 100))
    : 0

  return (
    <div className="space-y-5">
      <FormHeader
        title="Abone Hedefi"
        subtitle="İlerleme barı"
        status={form.status}
        savedAt={form.savedAt}
        error={form.error}
        onUndo={form.canUndo ? form.undo : undefined}
      />

      <div className="space-y-3">
        <div>
          <label className="block text-xs font-medium text-[var(--color-text-muted)] mb-1.5">Başlık</label>
          <Input value={form.draft.title} onChange={(e) => form.patch({ title: e.target.value })} />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-medium text-[var(--color-text-muted)] mb-1.5">Hedef</label>
            <Input
              type="number"
              value={form.draft.goal}
              onChange={(e) => form.patch({ goal: Number(e.target.value) })}
              min={1}
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-[var(--color-text-muted)] mb-1.5">Mevcut</label>
            <Input
              type="number"
              value={form.draft.current}
              onChange={(e) => form.patch({ current: Number(e.target.value) })}
              min={0}
            />
          </div>
        </div>
        <div>
          <label className="block text-xs font-medium text-[var(--color-text-muted)] mb-1.5">Renk</label>
          <input
            type="color"
            value={form.draft.color}
            onChange={(e) => form.patch({ color: e.target.value })}
            className="h-10 w-20 rounded border border-[var(--color-border)] bg-[var(--color-elevated)]"
          />
        </div>

        <div className="rounded-md p-3 bg-[var(--color-elevated)] border border-[var(--color-border)]">
          <div className="text-xs text-[var(--color-text-muted)] mb-2">Önizleme</div>
          <div className="h-6 bg-[var(--color-surface)] rounded overflow-hidden">
            <div
              className="h-full transition-all"
              style={{ width: `${pct}%`, background: form.draft.color }}
            />
          </div>
          <div className="text-xs mt-1.5 text-[var(--color-text-muted)]">
            {form.draft.current} / {form.draft.goal} ({pct}%)
          </div>
        </div>

        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input
            type="checkbox"
            checked={form.draft.show}
            onChange={(e) => form.patch({ show: e.target.checked })}
            className="accent-[var(--color-accent)]"
          />
          Barı göster
        </label>
      </div>
    </div>
  )
}
